<template>
  <div class="pos-rel">
    <div class="left-menu">
      <div>
        <div class="header__left-menu">
          <router-link to="/">
            <img :src="productImage" />
          </router-link>
        </div>
        <ul class="left-menu--list">
          <!-- <li id="maintenance" class="nav-parent">
            <router-link to="/inventory/maintenance" id="maintenance-link">
              <i class="ic-car"></i>
              Maintenance
            </router-link>
          </li> -->
          <!-- <li id="dashboard" class="nav-parent">
            <a
              href="javascript:void(0)"
              class="dropdown-toggle"
              data-toggle="dropdown"
              aria-expanded="true"
            >
              <i class="ic-transaction"></i>
              Dashboard
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu nav-master" role="menu">
              <li>
                <router-link to="/dashboard/tenant" id="tenant-dashboard-link">
                  Tenant Dashboard
                </router-link>
              </li>
              <li>
                <router-link
                  to="/dashboard/provider"
                  id="provider-dashboard-link"
                >
                  Provider Dashboard
                </router-link>
              </li>
            </ul>
          </li> -->
          <li
            v-if="isProviderCandidateVisible"
            id="onboarding"
            class="nav-parent"
          >
            <router-link to="/onboarding" id="provider-candidate-link">
              <i class="ic-businessmen"></i> On-Boarding
            </router-link>
          </li>
          <li
            v-if="
              isTenantReportVisible ||
              isProviderReportVisible ||
              isCustomerReportVisible
            "
            id="booking-history"
            class="nav-parent"
          >
            <a
              href="javascript:void(0)"
              class="dropdown-toggle"
              data-toggle="dropdown"
              aria-expanded="true"
            >
              <i class="ic-transactional-report"></i> Reporting
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu nav-master" role="menu">
              <li v-if="isTenantReportVisible">
                <router-link to="/report/tenant" id="tenant-report-link">
                  Tenant Transactions
                </router-link>
              </li>
              <li v-if="isProviderReportVisible">
                <router-link to="/report/provider" id="provider-report-link">
                  Provider Transactions
                </router-link>
              </li>
              <li v-if="isCustomerReportVisible">
                <router-link to="/report/customer" id="customer-report-link">
                  Customer Transactions
                </router-link>
              </li>
            </ul>
          </li>
          <li
            v-if="
              isAvailableJobVisible ||
              isTenantJobVisible ||
              isProviderJobVisible ||
              isDriverJobVisible
            "
            id="job"
            class="nav-parent"
          >
            <a
              href="javascript:void(0)"
              class="dropdown-toggle"
              data-toggle="dropdown"
              aria-expanded="true"
            >
              <i class="ic-booking-history"></i> Job Browser
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu nav-master" role="menu">
              <li v-if="isAvailableJobVisible">
                <router-link
                  to="/job/available"
                  id="available-job-browser-link"
                >
                  Open Jobs
                </router-link>
              </li>
              <li v-if="isTenantJobVisible">
                <router-link to="/job/tenant" id="tenant-job-browser-link">
                  Tenant Jobs
                </router-link>
              </li>
              <li v-if="isProviderJobVisible">
                <router-link to="/job/provider" id="provider-job-browser-link">
                  Provider Assigned
                </router-link>
              </li>
              <li v-if="isDriverJobVisible">
                <router-link to="/job/driver" id="driver-job-browser-link">
                  Driver Assigned
                </router-link>
              </li>
              <li>
                <router-link
                  to="/fleet/driver-tracker"
                  id="fleet-driver-tracker-link"
                >
                  Fleet Tracker
                </router-link>
              </li>
            </ul>
          </li>
          <li
            v-if="
              isMasterClassVisible ||
              isProviderVisible ||
              isPoolVisible ||
              isDriverVisible ||
              isPolicyVisible ||
              isVehicleVisible ||
              isRegionVisible
            "
            id="fleet-master"
            class="nav-parent"
          >
            <a
              href="javascript:void(0)"
              class="dropdown-toggle"
              data-toggle="dropdown"
              aria-expanded="true"
            >
              <i class="ic-car"></i> Fleet Master
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu nav-master" role="menu">
              <li
                v-if="isMasterClassVisible"
                id="master-class"
                class="nav-parent"
              >
                <router-link to="/fleet/class" id="masterclass-link">
                  Class Management</router-link
                >
              </li>
              <li v-if="isProviderVisible">
                <router-link to="/fleet/provider" id="provider-link">
                  Providers
                </router-link>
              </li>
              <li v-if="isDriverVisible">
                <router-link to="/fleet/driver" id="driver-link">
                  Drivers
                </router-link>
              </li>
              <li v-if="isVehicleVisible">
                <router-link to="/fleet/vehicle" id="vehicle-link">
                  Vehicles</router-link
                >
              </li>
            </ul>
          </li>
          <li v-if="isZoneVisible" id="zone" class="nav-parent">
            <router-link to="/geofence" id="zone-link">
              <i class="ic-tour"></i> Geofence
            </router-link>
          </li>
          <li
            v-if="
              isBuyingTariffAncillaryRateVisible ||
              isBuyingTariffRentalChauffeurRateVisible ||
              isBuyingTariffRentalSelfDriveRateVisible ||
              isBuyingTariffTransferRateVisible ||
              isBuyingTariffOverriddenRentalChauffeurRateVisible ||
              isBuyingTariffOverriddenRentalSelfDriveRateVisible ||
              isBuyingTariffOverriddenTransferRateVisible ||
              isBuyingTariffOverriddenSurchargeVisible
            "
            id="buying-tariff"
            class="nav-parent"
          >
            <a
              href="javascript:void(0)"
              class="dropdown-toggle"
              data-toggle="dropdown"
              aria-expanded="true"
            >
              <i class="ic-price-calculator"></i> Operator Tariff
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu nav-master" role="menu">
              <!-- <li
                v-if="
                  isBuyingTariffRentalChauffeurRateVisible &&
                  tariffScheme.globallyPerClass
                "
              >
                <router-link
                  to="/buying/chauffeur"
                  id="buying-rental-chauffeur-link"
                >
                  {{ rentalLabel }} &hyphen; Chauffeur
                </router-link>
              </li> -->
              <li
                v-if="
                  isBuyingTariffRentalChauffeurRateVisible &&
                  tariffScheme.globallyPerClass
                "
              >
                <router-link
                  to="/buying/hourly-chauffeur"
                  id="buying-rental-chauffeur-link-new"
                >
                  {{ rentalLabel }} &hyphen; Chauffeur
                </router-link>
              </li>
              <!-- <li
                v-if="
                  isBuyingTariffOverriddenRentalChauffeurRateVisible &&
                    tariffScheme.vehicleOverrides
                "
              >
                <router-link
                  to="/buying/chauffeur/override"
                  id="overridden-buying-rental-chauffeur-link"
                >
                  {{ rentalLabel }} &hyphen; Chauffeur
                </router-link>
              </li> -->
              <li
                v-if="
                  isBuyingTariffRentalSelfDriveRateVisible &&
                  tariffScheme.globallyPerClass
                "
              >
                <router-link
                  to="/buying/selfdrive"
                  id="buying-rental-selfdrive-link"
                >
                  {{ rentalLabel }} &hyphen; Self Drive
                </router-link>
              </li>
              <!-- <li
                v-if="
                  isBuyingTariffOverriddenRentalSelfDriveRateVisible &&
                    tariffScheme.vehicleOverrides
                "
              >
                <router-link
                  to="/buying/selfdrive/override"
                  id="overridden-buying-rental-selfdrive-link"
                >
                  {{ rentalLabel }} &hyphen; Self Drive
                </router-link>
              </li> -->
              <!-- <li
                v-if="
                  isBuyingTariffTransferRateVisible &&
                  tariffScheme.globallyPerClass
                "
              >
                <router-link to="/buying/transfer" id="buying-transfer-link">
                  Transfer
                </router-link>
              </li> -->
              <li
                v-if="
                  isBuyingTariffTransferRateVisible &&
                  tariffScheme.globallyPerClass
                "
              >
                <router-link
                  to="/buying/transfer"
                  id="buying-transfer-link-new"
                >
                  Transfer
                </router-link>
              </li>
              <!-- <li
                v-if="
                  isBuyingTariffOverriddenTransferRateVisible &&
                    tariffScheme.vehicleOverrides
                "
              >
                <router-link
                  to="/buying/transfer/override"
                  id="overridden-buying-transfer-link"
                >
                  Transfer
                </router-link>
              </li> -->
              <!-- <li v-if="isBuyingTariffAncillaryRateVisible">
                <router-link to="/buying/ancillary" id="buying-ancillary-link">
                  Ancillary
                </router-link>
              </li> -->
              <li
                v-if="
                  isBuyingTariffSurchargeVisible &&
                  tariffScheme.globallyPerClass
                "
              >
                <router-link to="/buying/surcharge" id="buying-surcharge-link">
                  Surcharges
                </router-link>
              </li>
              <!-- <li v-if="isBuyingTariffOverriddenSurchargeVisible && tariffScheme.vehicleOverrides">
                <router-link to="/buying/surcharge/override" id="overridden-buying-surcharge-link">
                  Surcharges
                </router-link>
              </li> -->
            </ul>
          </li>
          <li
            v-if="
              isSellingTariffRentalChauffeurRateVisible ||
              isSellingTariffRentalSelfDriveRateVisible ||
              isSellingTariffTransferRateVisible ||
              isSellingTariffAncillaryRateVisible ||
              isSellingTariffSurchargeVisible ||
              isSellingTariffMarkupVisible ||
              isSellingTariffIncentiveVisible ||
              isSellingTariffIncentiveCompanyVisible
            "
            id="selling-tariff"
            class="nav-parent"
          >
            <a
              href="javascript:void(0)"
              class="dropdown-toggle"
              data-toggle="dropdown"
              aria-expanded="true"
            >
              <i class="ic-price-calculator"></i> Booker Tariff
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu nav-master" role="menu">
              <!-- <li
                v-if="
                  isSellingTariffRentalChauffeurRateVisible &&
                  tariffScheme.globallyPerClass
                "
              >
                <router-link
                  to="/selling/chauffeur"
                  id="selling-rental-chauffeur-link"
                >
                  {{ rentalLabel }} &hyphen; Chauffeur
                </router-link>
              </li> -->
              <li
                v-if="
                  isSellingTariffRentalChauffeurRateVisible &&
                  tariffScheme.globallyPerClass
                "
              >
                <router-link
                  to="/selling/hourly-chauffeur"
                  id="selling-rental-chauffeur-link-new"
                >
                  {{ rentalLabel }} &hyphen; Chauffeur
                </router-link>
              </li>
              <li
                v-if="
                  isSellingTariffRentalSelfDriveRateVisible &&
                  tariffScheme.globallyPerClass
                "
              >
                <router-link
                  to="/selling/selfdrive"
                  id="selling-rental-selfdrive-link"
                >
                  {{ rentalLabel }} &hyphen; Self Drive
                </router-link>
              </li>
              <!-- <li
                v-if="
                  isSellingTariffTransferRateVisible &&
                  tariffScheme.globallyPerClass
                "
              >
                <router-link to="/selling/transfer" id="selling-transfer-link">
                  Transfer
                </router-link>
              </li> -->
              <li
                v-if="
                  isSellingTariffTransferRateVisible &&
                  tariffScheme.globallyPerClass
                "
              >
                <router-link
                  to="/selling/transfer"
                  id="selling-transfer-link-new"
                >
                  Transfer
                </router-link>
              </li>
              <li v-if="isSellingTariffAncillaryRateVisible">
                <router-link
                  to="/selling/ancillary"
                  id="selling-ancillary-link"
                >
                  Ancillary
                </router-link>
              </li>
              <li
                v-if="
                  isSellingTariffSurchargeVisible &&
                  (tariffScheme.globallyPerClass ||
                    tariffScheme.vehicleOverrides)
                "
              >
                <router-link
                  to="/selling/surcharge"
                  id="selling-surcharge-link"
                >
                  Surcharges
                </router-link>
              </li>
              <li v-if="isSellingTariffMarkupVisible">
                <router-link to="/selling/markup" id="selling-markup-link">
                  Markup
                </router-link>
              </li>
              <li v-if="isSellingTariffIncentiveVisible">
                <router-link
                  to="/selling/incentive"
                  id="selling-incentive-link"
                >
                  Incentives
                </router-link>
              </li>
              <li v-if="isSellingTariffIncentiveCompanyVisible">
                <router-link
                  to="/selling/company-incentive"
                  id="selling-company-incentive-link"
                >
                  Company Incentives
                </router-link>
              </li>
            </ul>
          </li>
          <li
            v-if="isCompanyVisible || isCustomerVisible"
            id="corporate"
            class="nav-parent"
          >
            <a
              href="javascript:void(0)"
              class="dropdown-toggle"
              data-toggle="dropdown"
              aria-expanded="true"
            >
              <i class="ic-office"></i> Corporate
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu nav-master" role="menu">
              <li v-if="isCompanyVisible">
                <router-link to="/corporate/company" id="company-link">
                  Company
                </router-link>
              </li>
              <li v-if="isCustomerVisible">
                <router-link to="/corporate/customer" id="customer-link">
                  Customer
                </router-link>
              </li>
            </ul>
          </li>
          <li
            v-if="
              userRoles.includes('Admin') ||
              userRoles.includes('Finance') ||
              userRoles.includes('Administrator')
            "
            id="deposit"
            class="nav-parent"
          >
            <a
              href="javascript:void(0)"
              class="dropdown-toggle"
              data-toggle="dropdown"
              aria-expanded="true"
            >
              <i class="ic-wallet"></i> Finance
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu nav-master" role="menu">
              <li>
                <router-link to="/finance/invoice" id="invoice-link">
                  Invoice
                </router-link>
              </li>
            </ul>
          </li>
          <li
            v-if="
              isSettingVisible ||
              isXrateVisible ||
              isShareVisible ||
              isPeakPeriodVisible ||
              isPickupOffsetVisible
            "
            id="administration"
            class="nav-parent"
          >
            <a
              href="javascript:void(0)"
              class="dropdown-toggle"
              data-toggle="dropdown"
              aria-expanded="true"
            >
              <i class="ic-settings-horizontal"></i> Administration
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu nav-master" role="menu">
              <li v-if="isSettingVisible">
                <router-link to="/administration/setting" id="setting-link">
                  Global Settings
                </router-link>
              </li>
              <li v-if="isPeakPeriodVisible">
                <router-link
                  to="/administration/peak-period"
                  id="public-holiday-link"
                >
                  Event Periods
                </router-link>
              </li>
              <li v-if="isPickupOffsetVisible">
                <router-link
                  to="/administration/pickup-offset"
                  id="pickup-offset-link"
                >
                  Pick-up Offset
                </router-link>
              </li>
              <li>
                <router-link
                  to="/administration/rate-tagging"
                  id="rate-tagging-link"
                >
                  Custom Tags
                </router-link>
              </li>
            </ul>
          </li>
          <li
            v-if="
              isIdentityPolicyVisible ||
              isIdentityRoleVisible ||
              isIdentityUserVisible
            "
            id="security"
            class="nav-parent"
          >
            <a
              href="javascript:void(0)"
              class="dropdown-toggle"
              data-toggle="dropdown"
              aria-expanded="true"
            >
              <i class="ic-manage-access"></i> Access Management
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu nav-master" role="menu">
              <li v-if="isIdentityPolicyVisible">
                <router-link
                  to="/security/permission"
                  id="identity-policy-link"
                >
                  Permissions
                </router-link>
              </li>
              <li v-if="isIdentityRoleVisible">
                <router-link to="/security/role" id="identity-role-link">
                  Roles
                </router-link>
              </li>
              <li v-if="isIdentityUserVisible">
                <router-link to="/security/user" id="identity-user-link">
                  Users
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div>
        <ul class="left-menu--list bottom">
          <li class="hidden">
            <a href="javascript:void(0)">
              Feature Introduction
              <span class="sts-brandNew">New</span>
            </a>
          </li>
          <li>
            <a
              href="https://support.trransfer.com/"
              target="_blank"
              id="user-link"
            >
              Help Center
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { UserType } from "@/models/constants";

export default {
  computed: {
    isServicesExist: function () {
      return this.allServices && this.allServices !== null;
    },
    isVehicleRepairementVisible: function () {
      return (
        this.isServicesExist &&
        (this.allServices["VehicleRepairement"] ||
          this.allServices["VehicleRepairementItem"])
      );
    },
    isTenantReportVisible: function () {
      return this.isServicesExist && this.allServices["TenantReport"];
    },
    isProviderReportVisible: function () {
      return this.isServicesExist && this.allServices["ProviderReport"];
    },
    isCustomerReportVisible: function () {
      return this.isServicesExist && this.allServices["CustomerReport"];
    },
    isAvailableJobVisible: function () {
      return this.isServicesExist && this.allServices["AvailableJob"];
    },
    isTenantJobVisible: function () {
      return this.isServicesExist && this.allServices["TenantJob"];
    },
    isProviderJobVisible: function () {
      return this.isServicesExist && this.allServices["ProviderJob"];
    },
    isDriverJobVisible: function () {
      return this.isServicesExist && this.allServices["DriverJob"];
    },
    isProviderVisible: function () {
      return this.isServicesExist && this.allServices["Provider"];
    },
    isPoolVisible: function () {
      return this.isServicesExist && this.allServices["Pool"];
    },
    isDriverVisible: function () {
      return this.isServicesExist && this.allServices["Driver"];
    },
    isPolicyVisible: function () {
      return this.isServicesExist && this.allServices["Policy"];
    },
    isVehicleVisible: function () {
      return this.isServicesExist && this.allServices["Vehicle"];
    },
    isPeakPeriodVisible: function () {
      return this.isServicesExist && this.allServices["PeakPeriod"];
    },
    isShareVisible: function () {
      return this.isServicesExist && this.allServices["Share"];
    },
    isMasterClassVisible: function () {
      return this.isServicesExist && this.allServices["MasterClass"];
    },
    isCompanyVisible: function () {
      return this.isServicesExist && this.allServices["Company"];
    },
    isCustomerVisible: function () {
      return this.isServicesExist && this.allServices["Customer"];
    },
    isDepositSummaryVisible: function () {
      return this.isServicesExist && this.allServices["Deposit"];
    },
    isDepositTopupDemandVisible: function () {
      return this.isServicesExist && this.allServices["DepositTopup"];
    },
    isDepositTopupApprovalVisible: function () {
      return this.isServicesExist && this.allServices["DepositTopup"];
    },
    isDepositRefundDemandVisible: function () {
      return this.isServicesExist && this.allServices["DepositRefund"];
    },
    isDepositRefundApprovalVisible: function () {
      return this.isServicesExist && this.allServices["DepositRefund"];
    },
    isDepositHistoryVisible: function () {
      return this.isServicesExist && this.allServices["DepositHistory"];
    },
    isRegionVisible: function () {
      return this.isServicesExist && this.allServices["Region"];
    },
    isPickupOffsetVisible: function () {
      return this.isServicesExist && this.allServices["PickUpOffset"];
    },
    isZoneVisible: function () {
      return this.isServicesExist && this.allServices["Zone"];
    },
    isXrateVisible: function () {
      return this.isServicesExist && this.allServices["ExchangeRate"];
    },
    isProviderCandidateVisible: function () {
      return this.isServicesExist && this.allServices["OnBoarding"];
    },
    isSettingVisible: function () {
      return this.isServicesExist && this.allServices["Setting"];
    },
    isIdentityPolicyVisible: function () {
      return this.isServicesExist && this.allServices["IdentityPolicy"];
    },
    isIdentityRoleVisible: function () {
      return this.isServicesExist && this.allServices["IdentityRole"];
    },
    isIdentityUserVisible: function () {
      return this.isServicesExist && this.allServices["IdentityUser"];
    },
    isBuyingTariffAncillaryRateVisible: function () {
      // return this.isServicesExist && this.allServices["BuyingTariffAncillaryRate"];
      return false;
    },
    isBuyingTariffRentalChauffeurRateVisible: function () {
      return (
        this.isServicesExist &&
        this.allServices["BuyingTariffRentalChauffeurRate"]
      );
    },
    isBuyingTariffRentalSelfDriveRateVisible: function () {
      return (
        this.isServicesExist &&
        this.allServices["BuyingTariffRentalSelfDriveRate"]
      );
    },
    isBuyingTariffTransferRateVisible: function () {
      return (
        this.isServicesExist && this.allServices["BuyingTariffTransferRate"]
      );
    },
    isBuyingTariffOverriddenRentalChauffeurRateVisible: function () {
      return (
        this.isServicesExist &&
        this.allServices["BuyingTariffOverriddenRentalChauffeurRate"]
      );
    },
    isBuyingTariffOverriddenRentalSelfDriveRateVisible: function () {
      return (
        this.isServicesExist &&
        this.allServices["BuyingTariffOverriddenRentalSelfDriveRate"]
      );
    },
    isBuyingTariffOverriddenTransferRateVisible: function () {
      return (
        this.isServicesExist &&
        this.allServices["BuyingTariffOverriddenTransferRate"]
      );
    },
    isBuyingTariffSurchargeVisible: function () {
      return (
        this.isServicesExist &&
        (this.allServices["BuyingTariffGeneralSurcharge"] ||
          this.allServices["BuyingTariffCancellationSurcharge"] ||
          this.allServices["BuyingTariffPeakPeriodSurcharge"] ||
          this.allServices["BuyingTariffWaitingTimeSurcharge"])
      );
    },
    isBuyingTariffOverriddenSurchargeVisible: function () {
      return (
        this.isServicesExist &&
        (this.allServices["BuyingTariffOverriddenGeneralSurcharge"] ||
          this.allServices["BuyingTariffOverriddenCancellationSurcharge"] ||
          this.allServices["BuyingTariffOverriddenPeakPeriodSurcharge"] ||
          this.allServices["BuyingTariffOverriddenWaitingTimeSurcharge"])
      );
    },
    isSellingTariffAncillaryRateVisible: function () {
      return (
        this.isServicesExist && this.allServices["SellingTariffAncillaryRate"]
      );
    },
    isSellingTariffRentalChauffeurRateVisible: function () {
      return (
        this.isServicesExist &&
        this.allServices["SellingTariffRentalChauffeurRate"]
      );
    },
    isSellingTariffRentalSelfDriveRateVisible: function () {
      return (
        this.isServicesExist &&
        this.allServices["SellingTariffRentalSelfDriveRate"]
      );
    },
    isSellingTariffTransferRateVisible: function () {
      return (
        this.isServicesExist && this.allServices["SellingTariffTransferRate"]
      );
    },
    isSellingTariffSurchargeVisible: function () {
      return (
        this.isServicesExist &&
        (this.allServices["SellingTariffGeneralSurcharge"] ||
          this.allServices["SellingTariffCancellationSurcharge"] ||
          this.allServices["SellingTariffPeakPeriodSurcharge"] ||
          this.allServices["SellingTariffWaitingTimeSurcharge"])
      );
    },
    isSellingTariffMarkupVisible: function () {
      return this.isServicesExist && this.allServices["SellingTariffMarkup"];
    },
    isSellingTariffIncentiveVisible: function () {
      return this.isServicesExist && this.allServices["SellingTariffIncentive"];
    },
    isSellingTariffIncentiveCompanyVisible: function () {
      return (
        this.isServicesExist &&
        this.allServices["SellingTariffIncentiveCompany"]
      );
    },
    cdn: function () {
      return process.env.VUE_APP_CDN;
    },
  },
  data() {
    return {
      logo: "",
      allServices: null,
      rentalLabel: null,
      tariffScheme: {
        setting: "",
        globallyPerClass: false,
        vehicleOverrides: false,
      },
      productImage: null,
      userType: null,
      UserType: UserType,
      userRoles: [],
    };
  },
  async created() {
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    const profile = await this.$store.dispatch("user/getProfile");

    this.userRoles = profile.roles;

    this.productImage = this.$helper.extractSetting(
      publicSettings,
      "SidebarLogo",
      `${this.cdn}/images/logo-icon-text.png`
    );

    this.setupLogo(publicSettings);
    this.setupRentalLabel(publicSettings);
    this.setupTariffScheme(publicSettings);

    this.allServices = profile.services;
    this.userType = profile.userType;
  },
  methods: {
    setupLogo(publicSettings) {
      this.logo = this.$helper.extractSetting(
        publicSettings,
        "Logo",
        `${process.env.VUE_APP_CDN}/images/logo-text.png`
      );
    },
    setupRentalLabel(publicSettings) {
      this.rentalLabel = this.$helper.extractSetting(
        publicSettings,
        "RentalLabel",
        "Hourly"
      );
    },
    setupTariffScheme(publicSettings) {
      const tariffSchemeSetting = this.$helper.extractSetting(
        publicSettings,
        "TariffScheme",
        "GloballyPerClass"
      );
      // const tariffSchemeSetting = 'GloballyPerClass';

      this.tariffScheme = {
        setting: tariffSchemeSetting,
        globallyPerClass: tariffSchemeSetting === "GloballyPerClass",
        vehicleOverrides: tariffSchemeSetting === "VehicleOverrides",
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/shared/Navigation.vue